module.exports = __webpack_public_path__ + "img/product_72.db59bbc.webp";